/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Message_PlaceholderInputs */

const en_contact_form_message_placeholder = /** @type {(inputs: Contact_Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What happened, and what did you expect? Screens and steps help.`)
};

const pl_contact_form_message_placeholder = /** @type {(inputs: Contact_Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co się stało i czego się spodziewałeś? Ekrany i kroki bardzo pomagają.`)
};

/**
* | output |
* | --- |
* | "What happened, and what did you expect? Screens and steps help." |
*
* @param {Contact_Form_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_form_message_placeholder = /** @type {((inputs?: Contact_Form_Message_PlaceholderInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Message_PlaceholderInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_form_message_placeholder(inputs)
	return en_contact_form_message_placeholder(inputs)
});